import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {displayUserState, displayUserRole, formatDate} from "../util/helpers";

export default function Main() {
    const [paginationDto, setPaginationDto] = useState();
    const [results, setResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();

    const page = searchParams.get("page") || '1';
    const role = searchParams.get("role");
    const mentorState = searchParams.get("mentorState");
    const searchType = searchParams.get("searchType") || 'NICKNAME';
    const keyword = searchParams.get("keyword") || '';

    const requestData = (e) => {
        const params = {};
        params.page = page;
        params.role = role;
        params.mentorState = mentorState;
        params.searchType = searchType;
        params.keyword = keyword;

        axios.get(`/admin/v1/members`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setResults(res.data.content);
            });
    }

    const search = () => {
        setPage(1);
        requestData();
    }

    const setPage = (value) => {
        searchParams.set("page", value);
        setSearchParams(searchParams);
    }

    useEffect(() => {
        requestData();
    }, [page, role, mentorState]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">회원관리 > 회원정보</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>회원유형</label>

                                                <select className="form-control float-right"
                                                        style={{width: '180px', marginRight: '20px'}}
                                                        onChange={e => {
                                                            searchParams.set("page", '1');
                                                            searchParams.set("role", e.target.value);
                                                            setSearchParams(searchParams);
                                                        }}
                                                        value={role}>
                                                    <option value="">모두</option>
                                                    <option value="PROVIDER">멘토</option>
                                                </select>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>검색</label>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>회원상태</label>

                                                <select className="form-control float-right"
                                                        style={{width: '180px', marginRight: '20px'}}
                                                        onChange={e => {
                                                            searchParams.set("page", '1');
                                                            searchParams.set("mentorState", e.target.value);
                                                            setSearchParams(searchParams);
                                                        }}
                                                        value={mentorState}>
                                                    <option value="">모두</option>
                                                    <option value="REQUESTED">멘토-승인요청</option>
                                                    <option value="REJECTED">멘토-승인반려</option>
                                                    <option value="APPROVED">멘토-승인완료</option>
                                                </select>

                                                <select className="form-control float-right"
                                                        style={{width: '140px', marginRight: '10px'}}
                                                        onChange={e => {
                                                            searchParams.set("page", '1');
                                                            searchParams.set("searchType", e.target.value);
                                                            setSearchParams(searchParams);
                                                        }}
                                                        value={searchType}>
                                                    <option value="NICKNAME">닉네임</option>
                                                    <option value="EMAIL">이메일</option>
                                                    <option value="ID">ID</option>
                                                </select>

                                                <input type="text" className="form-control float-right"
                                                       style={{width: '200px', marginRight: '20px'}}
                                                       placeholder="검색어를 입력하세요"
                                                       value={keyword}
                                                       onChange={e => {
                                                           searchParams.set("page", '1');
                                                           searchParams.set("keyword", e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               e.preventDefault();
                                                               search();
                                                           }
                                                       }} />

                                                <button type="submit" className="btn btn-info float-right"
                                                        style={{width: '80px', marginRight: '10px'}}
                                                        onClick={search}>
                                                    검색
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>아이디</th>
                                                    <th>ext-id</th>
                                                    <th>이메일</th>
                                                    <th>별명</th>
                                                    <th>가입일</th>
                                                    <th>가입경로</th>
                                                    <th>회원상태</th>
                                                    {/*<th>회원유형</th>*/}
                                                    <th>상세보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    results && results.map((item, index) => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.extId}</td>
                                                                <td>{item.email}</td>
                                                                <td>{item.nickname}</td>
                                                                <td>{formatDate(item.createdAt)}</td>
                                                                <td>{item.oauthType}</td>
                                                                <td>{displayUserState(item.userState)}</td>
                                                                {/*<td>*/}
                                                                {/*    { item.nickname === 'ADMIN' ? '관리자' : Array.isArray(item.roles) ? item.roles.map(role => displayUserRole(role)).join('/ ') : null }*/}
                                                                {/*</td>*/}
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-info">
                                                                        <Link to={`/page/users/detail?userId=${item.id}`}>보기</Link>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage} />
                        }

                    </section>
                </div>
            </div>
        </div>
    );
}
